import React from 'react';
import { IndexRoute, Route, Router, hashHistory } from 'react-router';

//^ *********************************************************
//^                  CFA I EXAM ROUTES
//^ *********************************************************
//* ~~~~~~~ CBT ROUTE ~~~~~~~~
import CFA1_TUTOR from './views/CFA1-2025/Tutor2023/Tutor2023.js';
import CFA1_CBT_FINISH from './views/CFA1-2025/CFA1CBT/FinishTest/index';
import CFA1_CBT_INTRODUCTION from './views/CFA1-2025/CFA1CBT/IntroductionInstruction/index.js';
import CFA1_CBT_MOCK from './views/CFA1-2025/CFA1CBT/MockList/index';
import CFA1_CBT_QUESTION from './views/CFA1-2025/CFA1CBT/Questions/index';
import CFA1_CBT_RESULT from './views/CFA1-2025/CFA1CBT/ResultGraph/index';
import CFA1_CBT_ATTEMPTED_TEST from './views/CFA1-2025/CFA1CBT/ViewAttemptedMocks/index';
//* ~~~~~~~ DASHBOARD ROUTE ~~~~~~~~
import CFA1_2025_DASHBOARD_VIEW_QUESTIONS from './views/CFA1-2025/Dashboard/ViewAllQues.js';
import CFA1_2025_DASHBOARD from './views/CFA1-2025/Dashboard/index.jsx';
//* ~~~~~~~ NOTES ROUTE ~~~~~~~~
import CFA1_2025_NOTES from './views/CFA1-2025/Notes/index.jsx';
import CFA1_2025_NOTES_READING_LIST from './views/CFA1-2025/Notes/ReadingList/ReadingsList.jsx';
import CFA1_2025_NOTES_VIEW from './views/CFA1-2025/Notes/View/ViewNotes.jsx';
import CFA1_2025_NOTES_LIST from './views/CFA1-2025/Notes/ViewNotesList/NotesList.jsx';
//* ~~~~~~~ VIDEOS ROUTE ~~~~~~~~
import CFA1_2025_VIDEOS from './views/CFA1-2025/Videos/index.jsx';
import CFA1_2025_VIDEO_LIST from './views/CFA1-2025/Videos/PlayList/VideoPlayList.jsx';
//* ~~~~~~~ QUESTION BANK ROUTE ~~~~~~~~
import CFA1_2025_QUESTION_BANK from './views/CFA1-2025/QuestionBank/index.jsx';
import CFA1_2025_QUESTION_BANK_READING_LIST from './views/CFA1-2025/QuestionBank/QuestionReadingList/ReadingsList.jsx';
import CFA1_2025_QUESTIONS_LIST from './views/CFA1-2025/QuestionBank/QuestionsViewList/QuestionsList.jsx';
import CFA1_2025_QUESTION_VIEW from './views/CFA1-2025/QuestionBank/QuestionView/QuestionView.jsx';
//* ~~~~~~~ QUIZ ROUTE ~~~~~~~~
import CFA1_2025_QUIZ_BEFORE_START from './views/CFA1-2025/Quizzes/BeforeStart';
import CFA1_2025_QUIZ_BEGIN from './views/CFA1-2025/Quizzes/BeginQuiz.js';
import CFA1_2025_QUIZ from './views/CFA1-2025/Quizzes/Quizzes';

import Full from './containers/Full/';
import Simple from './containers/Simple/';
import Cfa3Dashboard from './views/CFA3/Cfa3Dashboard/Cfa3Dashboard.js';
import Auth from './views/Pages/Auth/Auth';
import ResetPassword from './views/Pages/Auth/ResetPassword';
import Filldetails from './views/Pages/Filldetails';
import Selectexam from './views/Pages/Selectexam';
import Profile from './views/Profile/Profile.js';

import GMAT_BeforeStart from './views/GMAT/Quizzes/BeforeStart';
import GMAT_BeginCasequiz from './views/GMAT/Quizzes/BeginQuiz/BeginCasequiz';
import GMAT_BeginGraphquiz from './views/GMAT/Quizzes/BeginQuiz/BeginGraphQuiz';
import GMAT_BeginTablequiz from './views/GMAT/Quizzes/BeginQuiz/BeginTableQuiz';
import GMAT_BeginTabquiz from './views/GMAT/Quizzes/BeginQuiz/BeginTabsQuiz';
import GMAT_BeginTwopartquiz from './views/GMAT/Quizzes/BeginQuiz/BeginTwopartQuiz';
import GMAT_Beginquiz from './views/GMAT/Quizzes/Beginquiz';
import GMAT_Quizzes from './views/GMAT/Quizzes/Quizzes';
import PremiumCheckout from './views/PremiumCheckout/';
import Subscribe from './views/Subscribe/Subscribe.js';
import SelectPackage from './views/Subscribe/SelectPackages/SelectPackage.js';

import Addons from './views/Addons/';
import Cfa3flashquestion from './views/CFA3/Cfa3flashquestion/Cfa3flashquestion.js';
import Cfa3savedquestion from './views/CFA3/Cfa3savedquestion/Cfa3savedquestion.js';
import Cart from './views/Cart/Cart.js';
import Checkout from './views/Cart/Checkout.js';
import paymentProcessing from './views/Cart/paymentProcessing';
import ChangePassword from './views/ChangePassword/';
import OrderDiscription from './views/OrderDiscription/';
import OrderHistory from './views/OrderHistory/';
import AppSumo from './views/Pages/AppSumo/AppSumo';
import Cfa3EssayQuesPdf from './views/Pages/Cfa3EssayQuesPdf';
import CheckoutVerify from './views/Pages/CheckoutVerify/CheckoutVerify';
import FrmPdf from './views/Pages/FrmPdf/';
import Unsubscribe from './views/Pages/Unsubscribe/Unsubscribe';
import SetPassword from './views/SetPassword';
// import SelectExtras from './views/Subscribe/SelectExtras.js';
import SubscriptionDetail from './views/SubscriptionDetail';
import Thankyou from './views/Thankyou/';
import THANK_YOU from './views/Thankyou/WordPressThankYou.js';

import Cfa3BeforeStart from './views/CFA3/Cfa3BeforeStart/Cfa3BeforeStart.js';
import Cfa3Beginquiz from './views/CFA3/Cfa3Beginquiz/Cfa3Beginquiz.js';
import Cfa3EssayQuestions from './views/CFA3/Cfa3EssayQuestions/Cfa3EssayQuestions.js';
import Cfa3QuestionBank from './views/CFA3/Cfa3QuestionBank/Cfa3QuestionBank.js';
import Cfa3Quizzes from './views/CFA3/Cfa3Quizzes/Cfa3Quizzes.js';
import Cfa3cases from './views/CFA3/Cfa3cases/Cfa3cases.js';
import Cfa3chapter from './views/CFA3/Cfa3chapter/Cfa3chapter.js';

// CFA 3 Notes and video
import Cfa3_Notes from './views/CFA3/Notes/Notes';
import Cfa3_Notes_Viewques from './views/CFA3/Notes/NotesViewques';
import Cfa3_notes_beginchapters from './views/CFA3/Notes/Notesbeginchapters';
import Cfa3_notes_readings from './views/CFA3/Notes/Notesreadings';
import Cfa3_video_display from './views/CFA3/Videos/Cfavideodisplay';
import Cfa3_video_Lessons from './views/CFA3/Videos/VideoLessons';
/*SOA - Probability*/
import SOA_P_BeforeStart from './views/SOA/Probability/BeforeStart/BeforeStart';
import SOA_P_BeginChapters from './views/SOA/Probability/Beginchapters';
import SOA_P_Beginquiz from './views/SOA/Probability/Beginquiz/Beginquiz';
import SOA_P_DASHBOARD from './views/SOA/Probability/Dashboard';
import SOA_P_FlashQuestion from './views/SOA/Probability/FlashQuestion';
import SOA_P_FlashQuestionNotes from './views/SOA/Probability/FlashQuestionNotes';
import SOA_P_Notes from './views/SOA/Probability/Notes';
import SOA_P_NotesViewQues from './views/SOA/Probability/NotesViewques';
import SOA_P_BeingNotes from './views/SOA/Probability/Notesbeginchapters';
import SOA_P_NotesReading from './views/SOA/Probability/Notesreadings';
import SOA_P_QuestionBank from './views/SOA/Probability/QuestionBank';
import SOA_P_Quizzes from './views/SOA/Probability/Quizzes';
import SOA_P_Reading from './views/SOA/Probability/Readings';
import SOA_P_SavedQuestion from './views/SOA/Probability/SavedQuestion';
import SOA_P_Viewques from './views/SOA/Probability/Viewques';

import SOA_P_VideoDisplay from './views/SOA/Probability/VideoDisplay/index';
import SOA_P_VideoLessons from './views/SOA/Probability/VideoLessons/VideoLessons';
/*end SOA - Probability*/

// SOA _FM  (Financial Mathematics)
import SOA_FM_BeforeStart from './views/SOA/FinancialMathematics/BeforeStart/BeforeStart';
import SOA_FM_Beginchapters from './views/SOA/FinancialMathematics/Beginchapters/Beginchapters';
import SOA_FM_Beginquiz from './views/SOA/FinancialMathematics/Beginquiz/Beginquiz';
import SOA_FM_Dashboard from './views/SOA/FinancialMathematics/Dashboard/Dashboard';
import Soa_fm_flashquestion from './views/SOA/FinancialMathematics/FlashQuestion/FlashQuestion';
import Soa_fm_flashquestionnotes from './views/SOA/FinancialMathematics/FlashQuestionNotes/FlashQuestionNotes';
import SOA_FM_Notes from './views/SOA/FinancialMathematics/Notes/Notes';
import SOA_FM_BeingNotes from './views/SOA/FinancialMathematics/Notesbeginchapters/Notesbeginchapters';
import SOA_FM_QuestionBank from './views/SOA/FinancialMathematics/QuestionBank/QuestionBank';
import SOA_FM_Quizzes from './views/SOA/FinancialMathematics/Quizzes/Quizzes';
import SOA_FM_Readings from './views/SOA/FinancialMathematics/Readings/Readings';
import Soa_fm_savedquestion from './views/SOA/FinancialMathematics/SavedQuestion/SavedQuestion';

import SOA_FM_VideoDisplay from './views/SOA/FinancialMathematics/VideoDisplay/VideoDisplay';
import SOA_FM_VideoLessons from './views/SOA/FinancialMathematics/VideoLessons/VideoLessons';

/*end FORUM*/

import CFA2CBTFinish from './views/CBT/CFA2CBTNew/FinishTest/index';
import CFA2IntoductionInstruction from './views/CBT/CFA2CBTNew/IntoductionInstruction/index';
import CFA2CBTMockExams from './views/CBT/CFA2CBTNew/MockList/index';
import PathwayList from './views/CBT/pathway/Pathway.js';
import SessionList from './views/CBT/pathway/Session.js';
import AttemptedTest from './views/CBT/pathway/AttemptedTest.js';
import PathwayIntroduction from './views/CBT/pathway/Introduction.js';
import CFA2CBTQuestion from './views/CBT/CFA2CBTNew/Questions/index';
import CFA2CBTResult from './views/CBT/CFA2CBTNew/ResultGraph/index';
import CFA2CBTViewAttempted from './views/CBT/CFA2CBTNew/ViewAttemptedMocks/index';
import GMATDashboard from './views/GMAT/Dashboard/dashboard';
import GMATBeginchapters from './views/GMAT/QuestionBank/Beginchapters';
import GMAT_QUESTION_BANK from './views/GMAT/QuestionBank/QuestionBank';
import GMATReadings from './views/GMAT/QuestionBank/Readings';
import GMAT2Statement from './views/GMAT/QuestionBank/SpecialQuestions/GMAT2Statement.js';
import GMATCases from './views/GMAT/QuestionBank/SpecialQuestions/GMATCases';
import GMATMultipleStatement from './views/GMAT/QuestionBank/SpecialQuestions/GMATMultipleStatement.js';
import GMATTab from './views/GMAT/QuestionBank/SpecialQuestions/GMATTab.js';
import GMATTable from './views/GMAT/QuestionBank/SpecialQuestions/GMATTable.js';
import ViewGMATques from './views/GMAT/QuestionBank/Viewques';
import GMATVideoLessons from './views/GMAT/VideoLessons/VideoLessons';
import GMATvideodisplay from './views/GMAT/VideoLessons/videodisplay';
import AppRoutes from './views/config/AppRoutes';

//  ===================== CFA 2 -2025 - EXAMS START =====================

import Cfa2_2025_Dashboard from './views/CFA2-2025/Dashboard/Cfa2Dashboard';
import Cfa2_2025_notesreadings from './views/CFA2-2025/Notes/Cfa2notesreadings';
import Cfa2_2025_BeingNotes from './views/CFA2-2025/Notes/Cfanotesbeginchapters';
import Cfa2_2025_Notes from './views/CFA2-2025/Notes/Notes';
import Cfa2_2025_NotesViewques from './views/CFA2-2025/Notes/cfa2NotesViewques';
import Cfa2_2025_QuestionBank from './views/CFA2-2025/QuestionBank/Cfa2_2023QuestionBank';
import Cfa2_2025_cases from './views/CFA2-2025/QuestionBank/Cfa2cases';
import Cfa2_2025_chapter from './views/CFA2-2025/QuestionBank/Cfa2chapter';
import Cfa2_2025_beforestart from './views/CFA2-2025/Quizzes/Cfa2BeforeStart';
import Cfa2_2025_beginquiz from './views/CFA2-2025/Quizzes/Cfa2Beginquiz';
import Cfa2_2025_Quizzes from './views/CFA2-2025/Quizzes/Cfa2_2023Quizzes';
import Cfa2_2025_videodisplay from './views/CFA2-2025/Videos/Cfavideodisplay';
import Cfa2_2025_VideoLessons from './views/CFA2-2025/Videos/VideoLessons';

//  ===================== CFA 2 -2025 - EXAMS ENDS =====================

//  ===================== CFA 2 -2027 - EXAMS START (additive, employee-only preview) =====================
//  Cloned CFA2-2025 view tree, endpoints swapped to /cfa_2_2027* + /cfa2CBTMockExams2027 + /cfa_2_2027quizes.
//  Route tree lives at /cfa2/2027/*; access gated by examPreviewGuard (backend) + isEmployee (exam selector).
import Cfa2_2027_Dashboard from './views/CFA2-2027/Dashboard/Cfa2Dashboard';
import Cfa2_2027_notesreadings from './views/CFA2-2027/Notes/Cfa2notesreadings';
import Cfa2_2027_BeingNotes from './views/CFA2-2027/Notes/Cfanotesbeginchapters';
import Cfa2_2027_Notes from './views/CFA2-2027/Notes/Notes';
import Cfa2_2027_NotesViewques from './views/CFA2-2027/Notes/cfa2NotesViewques';
import Cfa2_2027_QuestionBank from './views/CFA2-2027/QuestionBank/Cfa2_2023QuestionBank';
import Cfa2_2027_cases from './views/CFA2-2027/QuestionBank/Cfa2cases';
import Cfa2_2027_chapter from './views/CFA2-2027/QuestionBank/Cfa2chapter';
import Cfa2_2027_beforestart from './views/CFA2-2027/Quizzes/Cfa2BeforeStart';
import Cfa2_2027_beginquiz from './views/CFA2-2027/Quizzes/Cfa2Beginquiz';
import Cfa2_2027_Quizzes from './views/CFA2-2027/Quizzes/Cfa2_2023Quizzes';
import Cfa2_2027_videodisplay from './views/CFA2-2027/Videos/Cfavideodisplay';
import Cfa2_2027_VideoLessons from './views/CFA2-2027/Videos/VideoLessons';
import CFA2CBT2027Finish from './views/CBT/CFA2CBTNew2027/FinishTest/index';
import CFA2CBT2027IntoductionInstruction from './views/CBT/CFA2CBTNew2027/IntoductionInstruction/index';
import CFA2CBT2027MockExams from './views/CBT/CFA2CBTNew2027/MockList/index';
import CFA2CBT2027Question from './views/CBT/CFA2CBTNew2027/Questions/index';
import CFA2CBT2027Result from './views/CBT/CFA2CBTNew2027/ResultGraph/index';
import CFA2CBT2027ViewAttempted from './views/CBT/CFA2CBTNew2027/ViewAttemptedMocks/index';
//  ===================== CFA 2 -2027 - EXAMS ENDS =====================

// ===================== EA - EXAMS =====================
import EA_Dashboard from './views/EA-Exams/Dashboard/dashboard';
import EA_Beginchapters from './views/EA-Exams/QuestionBank/Beginchapters';
import EA_QUESTION_BANK from './views/EA-Exams/QuestionBank/QuestionBank';
import EA_Readings from './views/EA-Exams/QuestionBank/Readings';
import EA_Cases from './views/EA-Exams/QuestionBank/SpecialQuestions/Cases';
import EA_MultipleStatement from './views/EA-Exams/QuestionBank/SpecialQuestions/MultipleStatement.js';
import EA_2Statement from './views/EA-Exams/QuestionBank/SpecialQuestions/Statement.js';
import EA_Tab from './views/EA-Exams/QuestionBank/SpecialQuestions/Tab.js';
import EA_Table from './views/EA-Exams/QuestionBank/SpecialQuestions/Table.js';
import EA_Viewques from './views/EA-Exams/QuestionBank/Viewques';
import EA_BeforeStart from './views/EA-Exams/Quizzes/BeforeStart';
import EA_BeginCasequiz from './views/EA-Exams/Quizzes/BeginQuiz/BeginQuizContainer.js';
import EA_BeginGraphquiz from './views/EA-Exams/Quizzes/BeginQuiz/BeginQuizContainer.js';
import EA_BeginTablequiz from './views/EA-Exams/Quizzes/BeginQuiz/BeginQuizContainer.js';
import EA_BeginTabquiz from './views/EA-Exams/Quizzes/BeginQuiz/BeginQuizContainer.js';
import EA_BeginTwopartquiz from './views/EA-Exams/Quizzes/BeginQuiz/BeginQuizContainer.js';
import EA_Beginquiz from './views/EA-Exams/Quizzes/BeginQuiz/BeginQuizContainer.js';
import EA_Quizzes from './views/EA-Exams/Quizzes/Quizzes';
import EA_VideoLessons from './views/EA-Exams/VideoLessons/VideoLessons';
import EA_Videodisplay from './views/EA-Exams/VideoLessons/videodisplay';

import CaseQuestions from './views/CFA3/Cfa3EssayQuestions/CaseQuestions.jsx';
import Chapters from './views/CFA3/Cfa3EssayQuestions/Chapters.jsx';
import EssayCases from './views/CFA3/Cfa3EssayQuestions/EssayCases.jsx';
//----------------------- ( CFA LEVEL 1 2024 ) IMPORT START HERE -------------------------------------
// ===================== CFA3 CBT =====================
import CFA3CBTFinish from './views/CBT/CFA3CBT/FinishTest/index';
import CFA3CBTGRADEQuestion from './views/CBT/CFA3CBT/GradeQuestion/index';
import CFA3CBTQuestion from './views/CBT/CFA3CBT/Questions/index';
import CFA3CBTResult from './views/CBT/CFA3CBT/ResultGraph/index';

// ====================== ESG ROUTES =====================
import { gmatFocusRoutes } from './routes/exams/gmat-focus';
import CBTFinishPage from './views/ESG/CBT/CBTFinishPage';
import CBTQuestion from './views/ESG/CBT/CBTQuestion';
import Instructions from './views/ESG/CBT/Instructions.jsx';
import CBTDetailedGraph from './views/ESG/CBT/ResultGraph/index';
import ViewAttemptedMock from './views/ESG/CBT/ViewAttemptedMock';
import ESGCBT from './views/ESG/CBT/index';
import ESGDashboard from './views/ESG/Dashboard/index';
import ESGNotes from './views/ESG/Notes/index';
import ESGBeginQuestion from './views/ESG/QuestionBank/BeginQuestion';
import QuestionsList from './views/ESG/QuestionBank/QuestionList';
import ESGQuestionBank from './views/ESG/QuestionBank/index';
import ESGVideoLesson from './views/ESG/Videos/ChapterVideos';
import ESGVideos from './views/ESG/Videos/index';
import RecurringPlanDetail from './views/SubscriptionDetail/RecurringPlanDetail';
import FRMVideoLessons from './views/FRM/FRMVideoLessons/FrmvideoLessons.js';
import Frmvideodisplay from './views/FRM/FRMVideoLessons/Frmvideodisplay/Frmvideodisplay.js';
import Frm1BeforeStart from './views/FRM/Frm1Quizzes/part-1/Frm1BeforeStart/Frm1BeforeStart.js';
import Frm1Beginquiz from './views/FRM/Frm1Quizzes/part-1/Frm1Beginquiz/Frm1Beginquiz.js';
import Frm1Quizzes from './views/FRM/Frm1Quizzes/part-1/Frm1Quizzes/Frm1Quizzes.js';
import Frm2BeforeStart from './views/FRM/Frm1Quizzes/part-2/Frm2BeforeStart/Frm2BeforeStart.js';
import Frm2Beginquiz from './views/FRM/Frm1Quizzes/part-2/Frm2Beginquiz/Frm2Beginquiz.js';
import FrmNotes from './views/FRM/FrmNotes/FrmNotes';
import FrmNotesBeginChapters from './views/FRM/FrmNotes/FrmNotesBeginChapters/FrmNotesBeginChapters.js';
import Frmnotesreadings from './views/FRM/FrmNotes/Frmnotesreadings/Frmnotesreadings.js';
import FrmQueBank from './views/FRM/FrmQueBank/FrmQueBank.js';
import FrmReadings from './views/FRM/FrmQueBank/FrmReadings/FrmReadings.js';
import Frmchapter from './views/FRM/FrmQueBank/Frmchapter/Frmchapter.js';
import ViewFrmQues from './views/FRM/FrmQueBank/ViewFrmQues/ViewFrmQues.js';
import Frmdashboard from './views/FRM/Frmdashboard/Frmdashboard';
import Frm2ViewAllQue from './views/FRM/Frmdashboard/ViewFrm2AllQues/ViewFrm2AllQues.js';
import FrmViewAllQue from './views/FRM/Frmdashboard/ViewFrmAllQues/ViewFrmAllQues.js';
//* FRM CBT
import FRMCBTFinish from './views/CBT/FRMCBT/FinishTest';
import FRMIntoductionInstruction from './views/CBT/FRMCBT/IntoductionInstruction';
import FRMCBTMockExams from './views/CBT/FRMCBT/MockList';
import FRMCBTQuestion from './views/CBT/FRMCBT/Questions';
import FRMCBTResult from './views/CBT/FRMCBT/ResultGraph/index.js';
import FRMCBTViewAttempted from './views/CBT/FRMCBT/ViewAttemptedMocks';

import FrmQuestionBank from './views/FRM-V2/Questionbank/index.jsx';
import FrmReadingList from './views/FRM-V2/Questionbank/QuestionReadingList/ReadingsList.jsx';
import FrmViewQuestionList from './views/FRM-V2/Questionbank/QuestionsViewList/QuestionsList.jsx';
import FrmViewQuestion from './views/FRM-V2/Questionbank/QuestionView/index.jsx';

import FrmV2Notes from './views/FRM-V2/Notes/index.jsx';
import FrmV2NotesReadingList from './views/FRM-V2/Notes/ReadingList/ReadingsList.jsx';
import FrmV2NotesView from './views/FRM-V2/Notes/View/ViewNotes.jsx';
import FrmV2Dashboard from './views/FRM-V2/Dashboard/index.jsx';
import FrmV2Videos from './views/FRM-V2/Videos/index.jsx';
import FrmV2VideoPlaylist from './views/FRM-V2/Videos/PlayList/VideoPlayList.jsx';
import VideosComponent from './views/Videos/index.jsx';
import VideosListing from './views/Videos/PlayList/index.jsx';
import { redirectSharedVideosToCfa2Tree } from './common/cfa2NextRoutes';

//Webinars
import WebinarsList from "./views/Webinars/WebinarsList";


export default (
  <Router history={hashHistory}>
    {/* Legacy CFA1 (2026) content moved from /cfa1/v2/* to /cfa1/2026/*. Redirect old links
        (bookmarks, indexed pages, in-app soft nav) so they keep working. A 301 at the domain/proxy
        handles SEO; this client-side redirect covers localhost + client-side navigations. Listed
        first so it matches before the '/' layout routes. Sub-path + query string are preserved. */}
    <Route
      path='/cfa1/v2'
      onEnter={(nextState, replace) => replace('/cfa1/2026/dashboard')}
    />
    <Route
      path='/cfa1/v2/*'
      onEnter={(nextState, replace) => {
        const loc = nextState.location;
        replace(loc.pathname.replace('/cfa1/v2', '/cfa1/2026') + (loc.search || ''));
      }}
    />
    {/* Legacy CFA1 (2026) CBT + quizzes moved from /cfa1_2024/* and /cfa1_2025/* to /cfa1/2026/*
        (unified with notes/videos/question-bank above, mirroring the 2027 /cfa1/2027/* layout). */}
    <Route
      path='/cfa1_2024/*'
      onEnter={(nextState, replace) => {
        const loc = nextState.location;
        replace(loc.pathname.replace('/cfa1_2024', '/cfa1/2026') + (loc.search || ''));
      }}
    />
    <Route
      path='/cfa1_2025/*'
      onEnter={(nextState, replace) => {
        const loc = nextState.location;
        replace(loc.pathname.replace('/cfa1_2025', '/cfa1/2026') + (loc.search || ''));
      }}
    />
    {/* CFA2 2026: the current CFA2 edition moved from /cfa2/v2/* (learn tree) and bare /cfa2/{cbt,
        introduction,viewattemptedmock,cbtquestions,cbtquestionsfinish,cbtshowresult} (CBT tree) to a
        unified /cfa2/2026/* layout. Redirect old links (bookmarks, in-app soft nav). Listed before the
        '/' layout routes so they match first. These match specific segments only — never /cfa2/2026/*
        or /cfa2/2027/* — so the new trees are not caught. Sub-path + query preserved. */}
    <Route path='/cfa2/v2' onEnter={(nextState, replace) => replace('/cfa2/2026/dashboard')} />
    <Route
      path='/cfa2/v2/*'
      onEnter={(nextState, replace) => {
        const loc = nextState.location;
        replace(loc.pathname.replace('/cfa2/v2', '/cfa2/2026') + (loc.search || ''));
      }}
    />
    <Route path='/cfa2/cbt' onEnter={(nextState, replace) => replace('/cfa2/2026/cbt')} />
    <Route
      path='/cfa2/introduction/*'
      onEnter={(nextState, replace) => {
        const loc = nextState.location;
        replace(loc.pathname.replace('/cfa2/', '/cfa2/2026/') + (loc.search || ''));
      }}
    />
    <Route
      path='/cfa2/viewattemptedmock/*'
      onEnter={(nextState, replace) => {
        const loc = nextState.location;
        replace(loc.pathname.replace('/cfa2/', '/cfa2/2026/') + (loc.search || ''));
      }}
    />
    <Route
      path='/cfa2/cbtquestions/*'
      onEnter={(nextState, replace) => {
        const loc = nextState.location;
        replace(loc.pathname.replace('/cfa2/', '/cfa2/2026/') + (loc.search || ''));
      }}
    />
    <Route
      path='/cfa2/cbtquestionsfinish/*'
      onEnter={(nextState, replace) => {
        const loc = nextState.location;
        replace(loc.pathname.replace('/cfa2/', '/cfa2/2026/') + (loc.search || ''));
      }}
    />
    <Route
      path='/cfa2/cbtshowresult/*'
      onEnter={(nextState, replace) => {
        const loc = nextState.location;
        replace(loc.pathname.replace('/cfa2/', '/cfa2/2026/') + (loc.search || ''));
      }}
    />
    <Route path='/' name='Login' component={Simple}>
      <IndexRoute component={Auth} />

      <Route
        path='resetpassword(/:tokenid)/(:mailid)'
        name='ForgetPassword'
        component={ResetPassword}
      />
      <Route path='/cfa3essayquespdf' name='Cfa3EssayQuesPdf' components={Cfa3EssayQuesPdf} />
      <Route path='/frmpdf' name='FrmPdf' components={FrmPdf} />
      <Route path='/selectexam' name='Select Exam' components={Selectexam} />
      <Route path='/unsubscribe' name='Unsubscribe' components={Unsubscribe} />
      <Route path='/fill-details' name='Select Exam' components={Filldetails} />
      <Route path='/checkoutVerify' name='Checkout Verify' components={CheckoutVerify} />
      <Route path={AppRoutes.THANK_YOU} name='Thank you' components={THANK_YOU} />

      <Route path='/appsumo' name='AppSumo' components={AppSumo} />
    </Route>
    <Route path='/' name='Home' component={Full}>
      //^ =========== CFA I ROUTE COMPONENT =============
      <Route path={AppRoutes.Tutor} name='Tutor' components={CFA1_TUTOR} />
      <Route
        path={AppRoutes.CFA1_2024_CBT_QUESTION_FINISH}
        name='cfacbtquestionsfinish 2024'
        components={CFA1_CBT_FINISH}
      />
      <Route
        path={AppRoutes.CFA1_2024_CBT_INTRODUCTION}
        name='introduction 2024'
        components={CFA1_CBT_INTRODUCTION}
      />
      <Route path={AppRoutes.CFA1_2025_QUIZZES} name='Quizzes' components={CFA1_2025_QUIZ} />
      <Route
        path={AppRoutes.CFA1_2025_QUIZ_BEFORE_START}
        name='Quizzes Before Starting'
        components={CFA1_2025_QUIZ_BEFORE_START}
      />
      <Route
        path={AppRoutes.CFA1_2025_QUIZ_BEGIN}
        name='Begin Quiz'
        components={CFA1_2025_QUIZ_BEGIN}
      />
      <Route path={AppRoutes.CFA1_2024_CBT} name='cfacbt' components={CFA1_CBT_MOCK} />
      <Route
        path={AppRoutes.CFA1_2024_CBT_VIEW_ATTEMPTED_MOCK}
        name='cfaviewattemptedmock 2024'
        components={CFA1_CBT_ATTEMPTED_TEST}
      />
      <Route
        path={AppRoutes.CFA1_2024_CBT_QUESTIONS}
        name='cfacbtquestions'
        components={CFA1_CBT_QUESTION}
      />
      <Route
        path={AppRoutes.CFA1_2024_DETAILED_RESULT_GRAPH}
        name='cfacbtshowresult'
        components={CFA1_CBT_RESULT}
      />
      <Route path={AppRoutes.CFA1_2025_NOTES} name='CFA Notes' component={CFA1_2025_NOTES} />
      <Route
        path={AppRoutes.CFA1_2025_NOTES_READING_LIST}
        name='CFA Notes'
        component={CFA1_2025_NOTES_READING_LIST}
      />
      <Route
        path={AppRoutes.CFA1_2025_NOTES_VIEW}
        name='CFA Notes View'
        component={CFA1_2025_NOTES_VIEW}
      />
      <Route
        path={AppRoutes.CFA1_2025_NOTES_LIST}
        name='CFA Notes List'
        component={CFA1_2025_NOTES_LIST}
      />
      <Route
        path={AppRoutes.CFA1_2025_DASHBOARD}
        name='CFA1_2025_DASHBOARD'
        component={CFA1_2025_DASHBOARD}
      />
      <Route path={AppRoutes.CFA1_VIDEOS} name='CFA1 2025 videos' component={CFA1_2025_VIDEOS} />
      <Route
        path={AppRoutes.CFA1_VIDEO_LIST}
        name='CFA1 2025 video list'
        component={CFA1_2025_VIDEO_LIST}
      />
      <Route
        path={AppRoutes.CFA1_2025_QUESTION_BANK}
        name='CFA1 2025 Question Bank'
        component={CFA1_2025_QUESTION_BANK}
      />
      <Route
        path={AppRoutes.CFA1_2025_QUESTION_BANK_READING_LIST}
        name='CFA1 2025 Reading List'
        component={CFA1_2025_QUESTION_BANK_READING_LIST}
      />
      <Route
        path={AppRoutes.CFA1_2025_QUESTION_VIEW}
        name='CFA1 2025 View Question'
        component={CFA1_2025_QUESTION_VIEW}
      />
      <Route
        path={AppRoutes.CFA1_2025_QUESTIONS_LIST}
        name='CFA1 2025 View Question List'
        component={CFA1_2025_QUESTIONS_LIST}
      />
      <Route
        path={AppRoutes.CFA1_2025_DASHBOARD_VIEW_QUESTIONS}
        name='CFA1 AllQuestions 2025'
        components={CFA1_2025_DASHBOARD_VIEW_QUESTIONS}
      />
      {/* ~~ CFA-I 2027 — /cfa1/2027/... tree. Reuses the CFA1-2025 view components; the URL
          forces cfa_2027 (see common/examUrlResolver.js). 2026 routes above are untouched. ~~ */}
      <Route
        path={AppRoutes.CFA1_2027_NEXT_DASHBOARD}
        name='CFA1 2027 Dashboard'
        component={CFA1_2025_DASHBOARD}
      />
      <Route
        path={AppRoutes.CFA1_2027_NEXT_DASHBOARD_VIEW_QUESTIONS}
        name='CFA1 2027 AllQuestions'
        components={CFA1_2025_DASHBOARD_VIEW_QUESTIONS}
      />
      <Route
        path={AppRoutes.CFA1_2027_NEXT_NOTES}
        name='CFA1 2027 Notes'
        component={CFA1_2025_NOTES}
      />
      <Route
        path={AppRoutes.CFA1_2027_NEXT_NOTES_READING_LIST}
        name='CFA1 2027 Notes Reading List'
        component={CFA1_2025_NOTES_READING_LIST}
      />
      <Route
        path={AppRoutes.CFA1_2027_NEXT_NOTES_VIEW}
        name='CFA1 2027 Notes View'
        component={CFA1_2025_NOTES_VIEW}
      />
      <Route
        path={AppRoutes.CFA1_2027_NEXT_NOTES_LIST}
        name='CFA1 2027 Notes List'
        component={CFA1_2025_NOTES_LIST}
      />
      <Route
        path={AppRoutes.CFA1_2027_NEXT_VIDEOS}
        name='CFA1 2027 Videos'
        component={CFA1_2025_VIDEOS}
      />
      <Route
        path={AppRoutes.CFA1_2027_NEXT_VIDEO_LIST}
        name='CFA1 2027 Video List'
        component={CFA1_2025_VIDEO_LIST}
      />
      <Route
        path={AppRoutes.CFA1_2027_NEXT_QUESTION_BANK}
        name='CFA1 2027 Question Bank'
        component={CFA1_2025_QUESTION_BANK}
      />
      <Route
        path={AppRoutes.CFA1_2027_NEXT_QUESTION_BANK_READING_LIST}
        name='CFA1 2027 Reading List'
        component={CFA1_2025_QUESTION_BANK_READING_LIST}
      />
      <Route
        path={AppRoutes.CFA1_2027_NEXT_QUESTIONS_LIST}
        name='CFA1 2027 Question List'
        component={CFA1_2025_QUESTIONS_LIST}
      />
      <Route
        path={AppRoutes.CFA1_2027_NEXT_QUESTION_VIEW}
        name='CFA1 2027 View Question'
        component={CFA1_2025_QUESTION_VIEW}
      />
      <Route
        path={AppRoutes.CFA1_2027_NEXT_QUIZZES}
        name='CFA1 2027 Quizzes'
        components={CFA1_2025_QUIZ}
      />
      <Route
        path={AppRoutes.CFA1_2027_NEXT_QUIZ_BEFORE_START}
        name='CFA1 2027 Quiz Before Start'
        components={CFA1_2025_QUIZ_BEFORE_START}
      />
      <Route
        path={AppRoutes.CFA1_2027_NEXT_QUIZ_BEGIN}
        name='CFA1 2027 Begin Quiz'
        components={CFA1_2025_QUIZ_BEGIN}
      />
      <Route
        path={AppRoutes.CFA1_2027_NEXT_CBT}
        name='CFA1 2027 CBT'
        components={CFA1_CBT_MOCK}
      />
      <Route
        path={AppRoutes.CFA1_2027_NEXT_CBT_VIEW_ATTEMPTED_MOCK}
        name='CFA1 2027 CBT Attempted'
        components={CFA1_CBT_ATTEMPTED_TEST}
      />
      <Route
        path={AppRoutes.CFA1_2027_NEXT_CBT_INTRODUCTION}
        name='CFA1 2027 CBT Introduction'
        components={CFA1_CBT_INTRODUCTION}
      />
      <Route
        path={AppRoutes.CFA1_2027_NEXT_CBT_QUESTIONS}
        name='CFA1 2027 CBT Questions'
        components={CFA1_CBT_QUESTION}
      />
      <Route
        path={AppRoutes.CFA1_2027_NEXT_CBT_QUESTION_FINISH}
        name='CFA1 2027 CBT Finish'
        components={CFA1_CBT_FINISH}
      />
      <Route
        path={AppRoutes.CFA1_2027_NEXT_DETAILED_RESULT_GRAPH}
        name='CFA1 2027 CBT Result'
        components={CFA1_CBT_RESULT}
      />
      {/* Shared /videos (CFA2 + CFA3). CFA2 users are redirected into their dated tree
          (/cfa2/2026 or /cfa2/2027) by selected exam; CFA3 stays here. */}
      <Route
        path={AppRoutes.VIDEOS}
        name='Videos'
        component={VideosComponent}
        onEnter={redirectSharedVideosToCfa2Tree}
      />
      <Route
        path={AppRoutes.VIDEOS_LIST}
        name='Videos-List'
        component={VideosListing}
        onEnter={redirectSharedVideosToCfa2Tree}
      />
      {/* CFA2 2026 + 2027 videos: same shared components, under /cfa2/2026 resp. /cfa2/2027 (prefix-aware nav) */}
      <Route path={AppRoutes.CFA2_2026_VIDEOS} name='CFA2 2026 Videos' component={VideosComponent} />
      <Route
        path={AppRoutes.CFA2_2026_VIDEOS_LIST}
        name='CFA2 2026 Videos-List'
        component={VideosListing}
      />
      <Route path={AppRoutes.CFA2_2027_VIDEOS} name='CFA2 2027 Videos' component={VideosComponent} />
      <Route
        path={AppRoutes.CFA2_2027_VIDEOS_LIST}
        name='CFA2 2027 Videos-List'
        component={VideosListing}
      />
      <Route
        path={AppRoutes.FRM_V2_QUESTION_BANK}
        name='Frm Question Bank'
        component={FrmQuestionBank}
      />
      <Route
        path={AppRoutes.FRM_V2_QUESTION_BANK_READING_LIST}
        name='Frm Reading List'
        component={FrmReadingList}
      />
      <Route
        path={AppRoutes.FRM_V2_QUESTION_BANK_QUESTION_VIEW}
        name='Frm View Question'
        component={FrmViewQuestion}
      />
      <Route
        path={AppRoutes.FRM_V2_QUESTION_BANK_QUESTION_LIST}
        name='Frm View Question List'
        component={FrmViewQuestionList}
      />
      <Route path={AppRoutes.FRM_V2_NOTES} name='Frm Notes' component={FrmV2Notes} />
      <Route
        path={AppRoutes.FRM_V2_NOTES_READING_LIST}
        name='Frm Notes'
        component={FrmV2NotesReadingList}
      />
      <Route path={AppRoutes.FRM_V2_NOTES_VIEW} name='Frm Notes View' component={FrmV2NotesView} />
      <Route path={AppRoutes.FRM_V2_DASHBOARD} name='Frm dashboad' component={FrmV2Dashboard} />
      <Route path={AppRoutes.FRM_VIDEOS} name='Frm Videos' component={FrmV2Videos} />
      <Route
        path={AppRoutes.FRM_V2_VIDEOS_PLAYLIST}
        name='Frm Video PlayList'
        component={FrmV2VideoPlaylist}
      />
      <Route
        path={AppRoutes.FRM_V2_VIDEOS_MOCK_PLAYLIST}
        name='Frm Video PlayList'
        component={FrmV2VideoPlaylist}
      />
      <Route path={AppRoutes.FRM_DASHBOARD} name='Frm Dashboard' component={Frmdashboard} />
      <Route
        path={AppRoutes.FRM_V2_DETAILS_STATS_LEVEL1}
        name='FrmAllQueBank'
        components={FrmViewAllQue}
      />
      <Route
        path={AppRoutes.FRM_V2_DETAILS_STATS_LEVEL2}
        name='Frm2AllQueBank'
        components={Frm2ViewAllQue}
      />
      <Route path='/frm/notes' name='FRM Notes' components={FrmNotes} />
      <Route
        path='/frm/notesreadings(/:chapter)'
        name='Frm Notes Readings'
        components={Frmnotesreadings}
      />
      <Route
        path='/frm/beginnotes(/:notesid)(/:readingid)(/:id)(/:offset)(/:level)'
        name='FRM Notes Beginchapters'
        components={FrmNotesBeginChapters}
      />
      <Route path='/frm/videoLessons' name='FRMVideoLessons' components={FRMVideoLessons} />
      <Route
        path='/frm/videodisplay(/:id)(/:showFreePremium)(/:type)(/:chapter_id)(/:index)'
        name='Frmvideodisplay'
        components={Frmvideodisplay}
      />
      <Route path='/frm/questionbank' name='FrmQueBank' components={FrmQueBank} />
      <Route
        path='/frm/readings(/:chapter)(/:selectedMenu)(/:level)(/:chapterName)'
        name='FrmReadings'
        components={FrmReadings}
      />
      <Route
        path='/frm/questions(/:id)(/:chapter_no)(/:reading)(/:subscriptionstatus)(/:chapter)(/:level)(/:selectedMenu)'
        name='ViewFrmQues'
        components={ViewFrmQues}
      />
      <Route
        path='/frm/chapter(/:notesid)(/:readingid)(/:id)(/:level)(/:offset)'
        name='Frmchapter'
        components={Frmchapter}
      />
      <Route path='/frm/cbt' name='frmcbt' components={FRMCBTMockExams} />
      <Route
        path='/frm/introduction/:id/:questiono/:timer/:level'
        name='introduction'
        components={FRMIntoductionInstruction}
      />
      <Route
        path='/frm/cbtquestions/:id/:questiono/:timer/:level/:testid/:offset/:isNegative/:timerStart'
        name='frmcbtquestions'
        components={FRMCBTQuestion}
      />
      <Route
        path='/frm/cbtquestionsfinish/:id/:questiono/:timer/:level/:testid/:offset'
        name='frmcbtquestionsfinish'
        components={FRMCBTFinish}
      />
      <Route
        path='/frm/viewattemptedmock/:id/:timer/:level'
        name='frmviewattemptedmock'
        components={FRMCBTViewAttempted}
      />
      <Route
        path={AppRoutes.FRM_DETAILED_RESULT_GRAPH}
        name='frmcbtshowresult'
        components={FRMCBTResult}
      />
      <Route path={AppRoutes.CFA3_PATHWAY_CBT} name='PathwayList' components={PathwayList} />
      <Route path={AppRoutes.CFA3_PATHWAY_SESSION} name='SessionList' components={SessionList} />
      <Route
        path={AppRoutes.CFA3_PATHWAY_CBT_VIEW_ATTEMPTED_MOCK}
        name='pathwayAttemptedTest'
        components={AttemptedTest}
      />
      <Route
        path={AppRoutes.CFA3_PATHWAY_CBT_INTRODUCTION}
        name='introduction'
        components={PathwayIntroduction}
      />
      <Route
        path={AppRoutes.CFA3_PATHWAY_CBT_QUESTIONS}
        name='sessionQuestions'
        components={CFA3CBTQuestion}
      />
      <Route
        path={AppRoutes.CFA3_PATHWAY_CBT_GRADE_QUESTIONS}
        name='questionGrade'
        components={CFA3CBTGRADEQuestion}
      />
      <Route
        path={AppRoutes.CFA3_PATHWAY_CBT_QUESTIONS_FINISH}
        name='pathawyTestFinish'
        components={CFA3CBTFinish}
      />
      <Route
        path={AppRoutes.CFA3_PATHWAY_CBT_DETAILED_RESULT_GRAPH}
        name='resultGraph'
        components={CFA3CBTResult}
      />
      <Route
        path={AppRoutes.CFA3_DASHBOARD}
        name='Cfa 3 Dashboard'
        component={(props) => <Cfa3Dashboard key={'cfa3'} {...props} />}
      />
      <Route
        key={'cfa3_2025'}
        path={AppRoutes.CFA3_DASHBOARD_2025}
        name='Cfa 3 Dashboard'
        component={(props) => <Cfa3Dashboard key={'cfa3_2025'} {...props} />}
      />
      <Route path={AppRoutes.PROFILE_ROUTE} name='Profile' components={Profile} />
      <Route path='/profile/discussions/:username' name='Profile' components={Profile} />
      <Route path='/profile/comments/:username' name='Profile' components={Profile} />
      <Route path='/premiumcheckout' name='PremiumCheckout' components={PremiumCheckout} />
      <Route path='/frm/quiz(/:quiz_id)' name='Frm  Begin Quiz' components={Frm1Quizzes} />
      <Route
        path='/frm/1/beforestart(/:quiz_id)(/:selectedMenu)(/:status_send)'
        name='Frm Quizzes Before Starting'
        components={Frm1BeforeStart}
      />
      <Route
        path='/frm/1/beginquiz(/:quiz_id)(/:offset)'
        name='FrmBegin Quiz'
        components={Frm1Beginquiz}
      />
      <Route
        path='/frm/2/beforestart(/:quiz_id)(/:selectedMenu)(/:status_send)'
        name='Frm Quizzes Before Starting'
        components={Frm2BeforeStart}
      />
      <Route
        path='/frm/2/beginquiz(/:quiz_id)(/:offset)(/:selectedMenu)'
        name='FrmBegin Quiz'
        components={Frm2Beginquiz}
      />
      <Route
        path='/cfa3_savedquestion'
        name='Cfa 3 Saved Question'
        components={Cfa3savedquestion}
      />
      <Route path='/cfa3_flashquestion' name='Cfa Flash Question' components={Cfa3flashquestion} />
      <Route
        path='/changepassword(/:selectedMenu)(/:username)'
        name='Change Password'
        components={ChangePassword}
      />
      <Route path='/setpassword' name='Set Password' components={SetPassword} />
      <Route
        path='/orderhistory(/:selectedMenu)(/:username)'
        name='Order History'
        components={OrderHistory}
      />
      <Route
        path='/orderdiscription(/:orderid)(/:selectedMenu)(/:username)'
        name='Order Discription'
        components={OrderDiscription}
      />
      <Route
        path={AppRoutes.SUBSCRIPTION_DETAILS}
        name='subscription detail'
        components={SubscriptionDetail}
      />
      <Route
        path={AppRoutes.RECURRING_PLAN_DETAILS}
        name='subscription detail'
        components={RecurringPlanDetail}
      />
      <Route path='/cfa3/questionBank' name='Cfa 2 QuestionBank' components={Cfa3QuestionBank} />
      <Route
        path='/cfa3/cases(/:id)(/:chapter_name)(/:total_cases)'
        name='Cfa 3 Cases'
        components={Cfa3cases}
      />
      <Route path='/cfa3/essayquestionpdf' name='Essay Pdf' components={Cfa3EssayQuestions} />
      <Route
        path={AppRoutes.CFA3_ESSAY_QUESTION_CHAPTERS}
        name='Essay Chapters'
        components={Chapters}
      />
      <Route
        path={AppRoutes.CFA3_ESSAY_QUESTION_CASES}
        name='Cfa 3 Essay Cases'
        components={EssayCases}
      />
      <Route
        path={AppRoutes.CFA3_ESSAY_QUESTION_CASE_VIEW}
        name='Cfa 3 Essay Cases'
        components={CaseQuestions}
      />
      <Route
        path='/cfa3/chapter(/:chapterid)(/:caseid)(/:case_offset)(/:question_number)(/:offset)'
        name='Cfa 3 Chapter'
        components={Cfa3chapter}
      />
      <Route path='/cfa3/quizzes' name='Cfa 3 Quizzes' components={Cfa3Quizzes} />
      <Route
        path='/cfa3/beforestart(/:quiz_id)(/:status_send)'
        name='Cfa 3 Before Start'
        components={Cfa3BeforeStart}
      />
      <Route
        path='/cfa3/beginquiz(/:quiz_id)(/:offset)'
        name='Cfa 3 Begin Quiz'
        components={Cfa3Beginquiz}
      />
      <Route
        path='/soa/probability/questionbank'
        name='SOA Probability QuestionBank'
        components={SOA_P_QuestionBank}
      />
      <Route
        path='/soa/probability/readings(/:chapter)(/:chapterName)'
        name='SOA Probability Readings'
        components={SOA_P_Reading}
      />
      <Route
        path='/soa/probability/viewquestions(/:id)(/:chapter_no)(/:reading)(/:chapter)(/:subscriptionstatus)'
        name='SOA Probability Viewques'
        components={SOA_P_Viewques}
      />
      <Route
        path='/soa/probability/beginchapter(/:notesid)(/:readingid)(/:id)(/:chapter)(/:offset)'
        name='SOA Probability Being Chapters'
        components={SOA_P_BeginChapters}
      />
      <Route path='/soa/probability/notes' name='SOA Probability Notes' components={SOA_P_Notes} />
      <Route
        path={AppRoutes.SOA_PROBABILITY_NOTES_READING}
        name='SOA Notes Reading'
        components={SOA_P_NotesReading}
      />
      <Route
        path='/soa/probability/notesviewques'
        name='SOA Probability Notes'
        components={SOA_P_NotesViewQues}
      />
      <Route
        path='/soa/probability/beginnotes(/:notesid)(/:readingid)(/:id)(/:offset)'
        name='SOA Probability begin Notes'
        components={SOA_P_BeingNotes}
      />
      <Route
        path='/soa/probability/dashboard'
        name='SOA Probability Dashboard'
        component={SOA_P_DASHBOARD}
      />
      <Route
        path='/soa/probability/savedquestion'
        name='SOA Probability Saved Question'
        component={SOA_P_SavedQuestion}
      />
      <Route
        path='/soa/probability/flashquestion'
        name='SOA Probability Flash Question'
        component={SOA_P_FlashQuestion}
      />
      <Route
        path='/soa/probability/flashquestionnotes'
        name='SOA Probability Flash Question - Notes'
        component={SOA_P_FlashQuestionNotes}
      />
      <Route
        path='/soa/probability/quizzes'
        name='SOA Probability Quizzes'
        components={SOA_P_Quizzes}
      />
      <Route
        path='/soa/probability/beforeStart(/:quiz_id)(/:status_send)'
        name='SOA Probability Before Start'
        components={SOA_P_BeforeStart}
      />
      <Route
        path='/soa/probability/beginquiz(/:quiz_id)(/:offset)'
        name='SOA Probability Begin Quiz'
        components={SOA_P_Beginquiz}
      />
      <Route
        path={AppRoutes.SOA_PROBABILITY_VIDEO_LESSONS}
        name='SOA Video Lessons'
        components={SOA_P_VideoLessons}
      />
      <Route
        path={AppRoutes.SOA_PROBABILITY_VIDEO_DISPLAY}
        name='SOA Video Display'
        components={SOA_P_VideoDisplay}
      />
      <Route
        path='/soa/financialmathematics/questionbank'
        name='SOA Financial Mathematics QuestionBank'
        components={SOA_FM_QuestionBank}
      />
      <Route
        path='/soa/financialmathematics/beginchapter(/:page)(/:notesid)(/:id)(/:offset)'
        name='SOA Financial Mathematics Being Chapters'
        components={SOA_FM_Beginchapters}
      />
      <Route
        path='/soa/financialmathematics/notes'
        name='SOA Financial Mathematics Notes'
        components={SOA_FM_Notes}
      />
      <Route
        path='/soa/financialmathematics/beginnotes(/:notesid)(/:id)(/:offset)'
        name='SOA Financial Mathematics begin Notes'
        components={SOA_FM_BeingNotes}
      />
      <Route
        path='/soa/financialmathematics/dashboard'
        name='SOA Financial Mathematics Dashboard'
        component={SOA_FM_Dashboard}
      />
      <Route
        path='/soa/financialmathematics/savedquestion'
        name='SOA Financial Mathematics Saved Question'
        component={Soa_fm_savedquestion}
      />
      <Route
        path='/soa/financialmathematics/flashquestion'
        name='SOA Financial Mathematics Flash Question'
        component={Soa_fm_flashquestion}
      />
      <Route
        path='/soa/financialmathematics/flashquestionnotes'
        name='SOA Financial Mathematics Flash Question - Notes'
        component={Soa_fm_flashquestionnotes}
      />
      <Route
        path='/soa/financialmathematics/quizzes'
        name='SOA Financial Mathematics Quizzes'
        components={SOA_FM_Quizzes}
      />
      <Route
        path='/soa/financialmathematics/beforeStart(/:quiz_id)(/:status_send)'
        name='SOA Financial Mathematics Before Start'
        components={SOA_FM_BeforeStart}
      />
      <Route
        path='/soa/financialmathematics/beginquiz(/:quiz_id)(/:offset)'
        name='SOA Financial Mathematics Begin Quiz'
        components={SOA_FM_Beginquiz}
      />
      <Route
        path='/soa/financialmathematics/readings(/:id)(/:page)'
        name='SOA Financial Mathematics Readings'
        components={SOA_FM_Readings}
      />
      <Route
        path='/soa/financialmathematics/videolessons'
        name='SOA Financial Mathematics Videos Lessons'
        components={SOA_FM_VideoLessons}
      />
      <Route
        path='/soa/financialmathematics/videodisplay(/:id)(/:showFreePremium)(/:type)(/:chapter_id)(/:index)'
        name='SOA Financial Mathematics Videos Display'
        components={SOA_FM_VideoDisplay}
      />
      <Route path='/subscribe' name='Subscribe' components={Subscribe} />
      <Route
        path='/subscribe/selectPackage(/:exam_name)(/:exam_id)'
        name='Select Package'
        components={SelectPackage}
      />
      {/* <Route
        path='/subscribe/selectPackage/SelectExtras/:examID/:planID'
        name='Select Package'
        components={SelectExtras}
      /> */}
      <Route path='/payment-processing' name='paymentProcessing' components={paymentProcessing} />
      <Route path='/cart' name='Cart' components={Cart} />
      <Route path='/checkout' name='Checkout' components={Checkout} />
      <Route path='/thankyou(/:order_id)' name='Thankyou' components={Thankyou} />
      <Route path='/addons' name='Addons' components={Addons} />
      <Route path={AppRoutes.CFA2_CBT} name='cfa2cbt' components={CFA2CBTMockExams} />
      <Route
        path={AppRoutes.CFA2_CBT_QUESTIONS}
        name='cfa2cbtquestions'
        components={CFA2CBTQuestion}
      />
      <Route
        path={AppRoutes.CFA2_CBT_QUESTIONS_FINISH}
        name='cfa2cbtquestionsfinish'
        components={CFA2CBTFinish}
      />
      <Route
        path={AppRoutes.CFA2_CBT_INTRODUCTION}
        name='introduction'
        components={CFA2IntoductionInstruction}
      />
      <Route
        path={AppRoutes.CFA2_DETAILED_RESULT_GRAPH}
        name='cfacbtshowresult'
        components={CFA2CBTResult}
      />
      <Route
        path={AppRoutes.CFA2_CBT_VIEW_ATTEMPTED_MOCK}
        name='cfa2viewattemptedmock'
        components={CFA2CBTViewAttempted}
      />
      {/* CFA2 2027 CBT (employee-only preview) — cloned tree hitting /cfa2CBTMockExams2027 */}
      <Route path={AppRoutes.CFA2_2027_CBT} name='cfa2cbt2027' components={CFA2CBT2027MockExams} />
      <Route
        path={AppRoutes.CFA2_2027_CBT_QUESTIONS}
        name='cfa2cbtquestions2027'
        components={CFA2CBT2027Question}
      />
      <Route
        path={AppRoutes.CFA2_2027_CBT_QUESTIONS_FINISH}
        name='cfa2cbtquestionsfinish2027'
        components={CFA2CBT2027Finish}
      />
      <Route
        path={AppRoutes.CFA2_2027_CBT_INTRODUCTION}
        name='introduction2027'
        components={CFA2CBT2027IntoductionInstruction}
      />
      <Route
        path={AppRoutes.CFA2_2027_DETAILED_RESULT_GRAPH}
        name='cfacbtshowresult2027'
        components={CFA2CBT2027Result}
      />
      <Route
        path={AppRoutes.CFA2_2027_CBT_VIEW_ATTEMPTED_MOCK}
        name='cfa2viewattemptedmock2027'
        components={CFA2CBT2027ViewAttempted}
      />
      <Route path={AppRoutes.CFA3_CBT} name='cfa3cbt' components={CFA2CBTMockExams} />
      <Route
        path={AppRoutes.CFA3_CBT_QUESTIONS}
        name='cfa3cbtquestions'
        components={CFA3CBTQuestion}
      />
      <Route
        path={AppRoutes.CFA3_CBT_GRADE_QUESTIONS}
        name='cfa3cbtgradequestions'
        components={CFA3CBTGRADEQuestion}
      />
      <Route
        path={AppRoutes.CFA3_CBT_QUESTIONS_FINISH}
        name='cfa3cbtquestionsfinish'
        components={CFA3CBTFinish}
      />
      <Route
        path={AppRoutes.CFA3_CBT_INTRODUCTION}
        name='introduction'
        components={CFA2IntoductionInstruction}
      />
      <Route
        path={AppRoutes.CFA3_CBT_DETAILED_RESULT_GRAPH}
        name='cfacbtshowresult'
        components={CFA3CBTResult}
      />
      <Route
        path={AppRoutes.CFA3_CBT_VIEW_ATTEMPTED_MOCK}
        name='cfa3viewattemptedmock'
        components={CFA2CBTViewAttempted}
      />
      <Route path={AppRoutes.GMAT_DASHBOARD} name='introduction' components={GMATDashboard} />
      <Route
        path={AppRoutes.GMAT_QUESTION_BANK}
        name='GMAT_QUESTION_BANK'
        components={GMAT_QUESTION_BANK}
      />
      <Route
        path={AppRoutes.GMAT_QUESTION_BANK_READING}
        name='GMAT_QUESTION_BANK_READING'
        components={GMATReadings}
      />
      <Route
        path={AppRoutes.GMAT_QUESTION_BANK_VIEW_QUE}
        name='GMAT_QUESTION_BANK_VIEW_QUE'
        components={GMATBeginchapters}
      />
      <Route
        path={AppRoutes.GMAT_QUESTION_BANK_LIST_QUE}
        name='GMAT_QUESTION_BANK_LIST_QUE'
        components={ViewGMATques}
      />
      <Route
        path={AppRoutes.GMAT_VIDEO_DISPLAY}
        name='GMAT_VIDEO_DISPLAY'
        components={GMATvideodisplay}
      />
      <Route
        path={AppRoutes.GMAT_VIDEO_LESSONS}
        name='GMAT_VIDEO_LESSONS'
        components={GMATVideoLessons}
      />
      <Route path={AppRoutes.GMAT_BEGINCASE} name='GMAT Case' components={GMATCases} />
      <Route
        path={AppRoutes.GMAT_TWO_PART_STATEMENT}
        name='GMAT 2 Statements'
        components={GMAT2Statement}
      />
      <Route
        path={AppRoutes.GMAT_GRAPH_MULTI_STATEMENT}
        name='GMAT Multiple Statement'
        components={GMATMultipleStatement}
      />
      <Route path={AppRoutes.GMAT_TAB} name='GMAT Tab' components={GMATTab} />
      <Route path={AppRoutes.GMAT_TABLE} name='GMAT Table' components={GMATTable} />
      <Route path={AppRoutes.GMAT_QUIZZES} name='Quizzes' components={GMAT_Quizzes} />
      <Route
        path={AppRoutes.GMAT_QUIZZES_BEFORE_START}
        name='Before start'
        components={GMAT_BeforeStart}
      />
      <Route path={AppRoutes.BEGIN_QUIZ} name='Begin quizzes' components={GMAT_Beginquiz} />
      <Route
        path={AppRoutes.BEGIN_CASE_QUIZ}
        name='Begin quizzes'
        components={GMAT_BeginCasequiz}
      />
      <Route
        path={AppRoutes.GMAT_QUIZZES_BEGIN}
        name='Begin quizzes'
        components={GMAT_BeginTabquiz}
      />
      <Route
        path={AppRoutes.BEGIN_TABLE_QUIZ}
        name='Begin quizzes'
        components={GMAT_BeginTablequiz}
      />
      <Route
        path={AppRoutes.BEGIN_GRAPH_QUIZ}
        name='Begin quizzes'
        components={GMAT_BeginGraphquiz}
      />
      <Route
        path={AppRoutes.BEGIN_TWOPART_QUIZ}
        name='Begin quizzes'
        components={GMAT_BeginTwopartquiz}
      />
      <Route path={AppRoutes.CFA3_NOTES} name='CFA Level 3 Notes' components={Cfa3_Notes} />
      <Route
        path={AppRoutes.CFA3_NOTES_READINGS}
        name='Cfa 3 Notes Readings'
        components={Cfa3_notes_readings}
      />
      <Route
        path={AppRoutes.CFA3_NOTES_VIEWQUES}
        name='Cfa 3 View Notes'
        components={Cfa3_Notes_Viewques}
      />
      <Route
        path={AppRoutes.CFA3_BEGIN_NOTES}
        name='Cfa Level 3 Notes Beginchapters'
        components={Cfa3_notes_beginchapters}
      />
      <Route
        path={AppRoutes.CFA3_VIDEO_LESSONS}
        name='CFA level 3 Video Lessons'
        components={Cfa3_video_Lessons}
      />
      <Route
        path={AppRoutes.CFA3_VIDEO_DISPLAY}
        name='Cfa 3 video display'
        components={Cfa3_video_display}
      />
      <Route path={AppRoutes.EA_DASHBOARD} name='introduction' components={EA_Dashboard} />
      <Route
        path={AppRoutes.EA_QUESTION_BANK}
        name='GMAT_QUESTION_BANK'
        components={EA_QUESTION_BANK}
      />
      <Route
        path={AppRoutes.EA_READING}
        name='GMAT_QUESTION_BANK_READING'
        components={EA_Readings}
      />
      <Route
        path={AppRoutes.EA_BEGINCHAPTER}
        name='GMAT_QUESTION_BANK_VIEW_QUE'
        components={EA_Beginchapters}
      />
      <Route
        path={AppRoutes.VIEW_EA_QUESTION}
        name='GMAT_QUESTION_BANK_LIST_QUE'
        components={EA_Viewques}
      />
      <Route
        path={AppRoutes.EA_VIDEO_DISPLAY}
        name='GMAT_VIDEO_DISPLAY'
        components={EA_Videodisplay}
      />
      <Route
        path={AppRoutes.EA_VIDEO_LESSONS}
        name='GMAT_VIDEO_LESSONS'
        components={EA_VideoLessons}
      />
      <Route path={AppRoutes.EA_BEGINCASE} name='GMAT Case' components={EA_Cases} />
      <Route
        path={AppRoutes.EA_TWO_PART_STATEMENT}
        name='GMAT 2 Statements'
        components={EA_2Statement}
      />
      <Route
        path={AppRoutes.EA_GRAPH_MULTI_STATEMENT}
        name='GMAT Multiple Statement'
        components={EA_MultipleStatement}
      />
      <Route path={AppRoutes.EA_TAB} name='GMAT Tab' components={EA_Tab} />
      <Route path={AppRoutes.EA_TABLE} name='GMAT Table' components={EA_Table} />
      <Route path={AppRoutes.EA_QUIZZES} name='Quizzes' components={EA_Quizzes} />
      <Route path={AppRoutes.EA_BEFORE_START} name='Before start' components={EA_BeforeStart} />
      <Route path={AppRoutes.EA_BEGIN_QUIZ} name='Begin quizzes' components={EA_Beginquiz} />
      <Route
        path={AppRoutes.EA_BEGIN_CASE_QUIZ}
        name='Begin quizzes'
        components={EA_BeginCasequiz}
      />
      <Route path={AppRoutes.EA_BEGIN_TAB_QUIZ} name='Begin quizzes' components={EA_BeginTabquiz} />
      <Route
        path={AppRoutes.EA_BEGIN_TABLE_QUIZ}
        name='Begin quizzes'
        components={EA_BeginTablequiz}
      />
      <Route
        path={AppRoutes.EA_BEGIN_GRAPH_QUIZ}
        name='Begin quizzes'
        components={EA_BeginGraphquiz}
      />
      <Route
        path={AppRoutes.EA_BEGIN_TWOPART_QUIZ}
        name='Begin quizzes'
        components={EA_BeginTwopartquiz}
      />
      <Route
        path={AppRoutes.CFA1_2025_DASHBOARD_VIEW_QUESTIONS}
        name='CFA1 AllQuestions 2025'
        components={CFA1_2025_DASHBOARD_VIEW_QUESTIONS}
      />
      {/* -------------------------- ( NEW CFA2_2025 ) ROUTE  START  HERE ------------------  */}
      <Route
        path={AppRoutes.CFA2_2025_DASHBOARD}
        name='CFA2_2025_DASHBOARD'
        component={Cfa2_2025_Dashboard}
      />
      <Route
        path={AppRoutes.CFA2_2025_QUESTION_BANK}
        name='Cfa 2 QuestionBank'
        components={Cfa2_2025_QuestionBank}
      />
      <Route
        path={AppRoutes.CFA2_2025_QUESTION_BANK_CASES}
        name='Cfa 2 Cases'
        components={Cfa2_2025_cases}
      />{' '}
      <Route
        path={AppRoutes.CFA2_2025_QUESTION_BANK_CASES_QUESTION}
        name='Cfa 2 Chapter'
        components={Cfa2_2025_chapter}
      />
      <Route
        path={AppRoutes.CFA2_2025_QUIZZES}
        name='Cfa 2 Quizzes'
        components={Cfa2_2025_Quizzes}
      />
      <Route
        path={AppRoutes.CFA2_2025_QUIZZES_BEFORE_START}
        name='Cfa 2 Before Start'
        components={Cfa2_2025_beforestart}
      />
      <Route
        path={AppRoutes.CFA2_2025_QUIZZES_BEGIN}
        name='Cfa 2 Begin Quiz'
        components={Cfa2_2025_beginquiz}
      />
      <Route
        path={AppRoutes.CFA2_2025_NOTES_QUES_VIEW}
        name='Cfa 2 View Notes'
        components={Cfa2_2025_NotesViewques}
      />
      <Route
        path={AppRoutes.CFA2_2025_NOTES_READINGS}
        name='Cfa 2 Notes Readings'
        components={Cfa2_2025_notesreadings}
      />
      <Route
        path={AppRoutes.CFA2_2025_NOTES}
        name='CFA Level 2 2025 Notes'
        components={Cfa2_2025_Notes}
      />
      <Route
        path={AppRoutes.CFA2_2025_VIDEO_DISPLAY}
        name='Cfa2videodisplay'
        components={Cfa2_2025_videodisplay}
      />
      <Route
        path={AppRoutes.CFA2_2025_VIDEO_LESSONS}
        name='CFA level 2 2025 Video Lessons'
        components={Cfa2_2025_VideoLessons}
      />
      <Route
        path={AppRoutes.CFA2_2025_BEGIN_NOTES}
        name='Cfa Level 2 2025 Notes Beginchapters'
        components={Cfa2_2025_BeingNotes}
      />
      {/* -------------------------- ( NEW CFA2_2027 — employee-only preview ) ROUTE START HERE ------------------ */}
      <Route
        path={AppRoutes.CFA2_2027_DASHBOARD}
        name='CFA2_2027_DASHBOARD'
        component={Cfa2_2027_Dashboard}
      />
      <Route
        path={AppRoutes.CFA2_2027_QUESTION_BANK}
        name='Cfa 2 2027 QuestionBank'
        components={Cfa2_2027_QuestionBank}
      />
      <Route
        path={AppRoutes.CFA2_2027_QUESTION_BANK_CASES}
        name='Cfa 2 2027 Cases'
        components={Cfa2_2027_cases}
      />
      <Route
        path={AppRoutes.CFA2_2027_QUESTION_BANK_CASES_QUESTION}
        name='Cfa 2 2027 Chapter'
        components={Cfa2_2027_chapter}
      />
      <Route
        path={AppRoutes.CFA2_2027_QUIZZES}
        name='Cfa 2 2027 Quizzes'
        components={Cfa2_2027_Quizzes}
      />
      <Route
        path={AppRoutes.CFA2_2027_QUIZZES_BEFORE_START}
        name='Cfa 2 2027 Before Start'
        components={Cfa2_2027_beforestart}
      />
      <Route
        path={AppRoutes.CFA2_2027_QUIZZES_BEGIN}
        name='Cfa 2 2027 Begin Quiz'
        components={Cfa2_2027_beginquiz}
      />
      <Route
        path={AppRoutes.CFA2_2027_NOTES_QUES_VIEW}
        name='Cfa 2 2027 View Notes'
        components={Cfa2_2027_NotesViewques}
      />
      <Route
        path={AppRoutes.CFA2_2027_NOTES_READINGS}
        name='Cfa 2 2027 Notes Readings'
        components={Cfa2_2027_notesreadings}
      />
      <Route
        path={AppRoutes.CFA2_2027_NOTES}
        name='CFA Level 2 2027 Notes'
        components={Cfa2_2027_Notes}
      />
      <Route
        path={AppRoutes.CFA2_2027_VIDEO_DISPLAY}
        name='Cfa2 2027 videodisplay'
        components={Cfa2_2027_videodisplay}
      />
      <Route
        path={AppRoutes.CFA2_2027_VIDEO_LESSONS}
        name='CFA level 2 2027 Video Lessons'
        components={Cfa2_2027_VideoLessons}
      />
      <Route
        path={AppRoutes.CFA2_2027_BEGIN_NOTES}
        name='Cfa Level 2 2027 Notes Beginchapters'
        components={Cfa2_2027_BeingNotes}
      />
      <Route path={AppRoutes.ESG_DASHBOARD} name='ESG Dashboard' component={ESGDashboard} />{' '}
      <Route path={AppRoutes.ESG_NOTES} name='ESG Notes' component={ESGNotes} />{' '}
      <Route path={AppRoutes.ESG_VIDEOS} name='ESG Notes' component={ESGVideos} />{' '}
      <Route path={AppRoutes.ESG_VIDEO_LESSON} name='ESG Notes' component={ESGVideoLesson} />{' '}
      <Route
        path={AppRoutes.ESG_QUESTION_BANK}
        name='ESG Question Bank'
        component={ESGQuestionBank}
      />{' '}
      <Route path={AppRoutes.ESG_CBT} name='ESG CBT' component={ESGCBT} />
      <Route
        path={AppRoutes.ESG_QUESTION_BANK_VIEW_QUE}
        name='ESG Begin Question'
        component={ESGBeginQuestion}
      />
      <Route
        path={AppRoutes.ESG_CBT_VIEW_ATTEMPTED_MOCK}
        name='ESG Begin Question'
        component={ViewAttemptedMock}
      />
      <Route
        path={AppRoutes.ESG_CBT_INTRODUCTION}
        name='ESG Begin Question'
        component={Instructions}
      />
      <Route path={AppRoutes.ESG_CBT_QUESTIONS} name='ESG Begin Question' component={CBTQuestion} />
      <Route
        path={AppRoutes.ESG_CBT_FINISH_PAGE}
        name='ESG Begin Question'
        component={CBTFinishPage}
      />
      <Route
        path={AppRoutes.ESG_QUESTION_BANK_LIST_QUE}
        name='ESG Questions List'
        component={QuestionsList}
      />
      <Route
        path={AppRoutes.ESG_CBT_DETAILED_STATS_GRAPH}
        name='ESG CBT Detailed Graph'
        component={CBTDetailedGraph}
      />
      {/* ================ ESG Routes ============================== */}
      {/* -------------------------- GMAT Focus  START  HERE ------------------  */}
      {gmatFocusRoutes.map((element) => (
        <Route path={element.path} name={element.name} component={element.component} />
      ))}

      {/*  --------- Webinars ---------------  */}
      <Route path='/webinars' name='Webinars' components={WebinarsList} />
    </Route>{' '}
    <Route path='/*' name='FRM Notes' components={Auth} />
  </Router>
);



// WEBPACK FOOTER //
// ./src/routes.js